import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const DeleteMessage = ({ setDeleteObj, confirmDelete }) => {
  return (
    <Dialog open onClose={() => setDeleteObj(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        Delete
        <IconButton
          aria-label="close"
          onClick={() => setDeleteObj(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete this?</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setDeleteObj(false)}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={confirmDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteMessage;
